import { render, staticRenderFns } from "./WeiBoCallback.vue?vue&type=template&id=4f6fdbd8&scoped=true&"
import script from "./WeiBoCallback.vue?vue&type=script&lang=js&"
export * from "./WeiBoCallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f6fdbd8",
  null
  
)

export default component.exports